import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export interface CTMSStudyEntity {
    Id: number;
    Name: string;
}

export class SiteLevelSummaryDto {
    Id: number;
    SiteId: number;
    SiteNumber: number;
    SiteName: string;
    //CTMSStudy: CTMSStudyEntity[];
    //StudyList: string[];
    StudyId: number;
    StudyName: string;
    UserNames: string[];

    constructor() { }

    initialize(): void {
        //this.StudyList = this.CTMSStudy?.map(study => study.Name) ?? [];
    }

    matchesFilter(study: any, siteManagers: any): boolean {
        // Study filter: match by StudyName or StudyId
        //if (!DoArraysOverlap(study, this.StudyList)) { return false; }
        if (study && study.length > 0) {
            if (!study.includes(this.StudyName)) {
                return false;
            }
        }
        // Site Manager filter
        let values: string[] = [];
        if (this.UserNames.length > 0) { values.push(...this.UserNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(siteManagers, values)) { return false; }

        return true;
    }
}

export class ActionItemListingDto {
    Id: number;
    Type: string;
    Status: string;
    SiteName: string;
    DateDue: string;
    IsUrgent: boolean;
    IsCritical: boolean;
    UserNames: string[];

    constructor() { }

    initialize(): void {
    }

    matchesFilter(site: any, status: any, type: any, critical: any, person: any, dueDateFilter: { operator: string, date1: string, date2: string }): boolean {
        // If any filter is undefined or an empty array, return false
        if (!site || site.length === 0) return false;
        if (!status || status.length === 0) return false;
        if (!type || type.length === 0) return false;
        if (!critical || critical.length === 0) return false;
        if (!person || person.length === 0) return false;

        // Site filter
        if (!site.includes(this.SiteName)) return false;
        // Status filter
        if (!status.includes(this.Status)) return false;
        // Type filter
        if (!type.includes(this.Type)) return false;
        // Critical filter
        const criticalLabel = this.IsCritical ? "Critical" : "Not Critical";
        if (!critical.includes(criticalLabel)) return false;
        // Person Responsible filter
        let values: string[] = [];
        if (this.UserNames.length > 0) { values.push(...this.UserNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(person, values)) { return false; }

        // Due Date filter
        if (dueDateFilter && dueDateFilter.operator && dueDateFilter.date1) {
            const itemDate = this.DateDue;
            const op = dueDateFilter.operator;
            const d1 = dueDateFilter.date1;
            const d2 = dueDateFilter.date2;
            if (!itemDate) return false;
            if (op === "on") {
                if (itemDate !== d1) return false;
            } else if (op === "before") {
                if (!(itemDate < d1)) return false;
            } else if (op === "after") {
                if (!(itemDate > d1)) return false;
            } else if (op === "between") {
                if (!d1 || !d2) return true;
                if (!(itemDate >= d1 && itemDate <= d2)) return false;
            }
        }

        return true;
    }
}

export class ActionItemDropdown {
    Id: number;
    Name: string;
    constructor() { }
}

export class AssignedSiteStudyDto {
    SiteStudyId: number;
    SiteId: number;
    SiteName: string;
    StudyId: number;
    StudyName: string;
    constructor() {}
}

export class SaveActionItemDto {
    Id: number;
    TypeId: number;
    TypeName?: string;
    Source: string;
    StatusId: number;
    DateIdentified: string;
    DateDue: string;
    IsUrgent: boolean;
    IsCritical: boolean;
    CriticalTypeId: number | null;
    CTMSCommunicationEventId: number | null;
    Notes: string;
    AssignedSiteStudies: AssignedSiteStudyDto[];
    constructor() {}
}